import { Controller } from "@hotwired/stimulus";

// Filet de sécurité du suivi d'import des parents.
//
// L'avancement arrive normalement par Turbo Stream, poussé par le worker. Mais
// une connexion WebSocket peut ne jamais s'établir (proxy d'entreprise, réseau
// mobile capricieux) : l'utilisateur resterait alors devant une barre figée à
// 0 % alors que l'import est terminé depuis longtemps. On interroge donc le
// statut à intervalle lâche, et on ne recharge la page que si l'état affiché
// ne correspond plus à la réalité.
export default class extends Controller {
  static values = {
    url: String,
    completed: Boolean,
    interval: { type: Number, default: 8000 },
  };

  connect() {
    if (this.completedValue) return;

    this.timer = setInterval(() => this.check(), this.intervalValue);
  }

  disconnect() {
    this.stop();
  }

  async check() {
    // La diffusion Turbo est bien passée : la carte affiche déjà l'état final.
    // Inutile d'interroger le serveur, et surtout de recharger la page.
    if (this.element.querySelector('[data-import-completed="true"]')) {
      this.stop();
      return;
    }

    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "application/json" },
      });
      if (!response.ok) return;

      const data = await response.json();
      if (!data.completed) return;

      // Terminé côté serveur mais la page ne le sait pas : la diffusion n'est
      // pas passée. On recharge une fois, puis on arrête d'interroger.
      this.stop();
      window.location.reload();
    } catch {
      // Réseau indisponible : on réessaiera au prochain battement.
    }
  }

  stop() {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  }
}
